module.exports = __webpack_public_path__ + "static/media/q3.a6bfc4cf.svg";